import React from 'react';
import { Stack, Typography } from '@mui/material';

import { dateFormmater } from '../../helpers/dateFormat';

export default function CertificationContactClient({ client, formValues }) {

    //client trae de bbdd: {name, tel, email, fax, movil, address, cif, id, cp, contacts, bank}
    //formValues trae de formulario: {characteristics, status, client, contact, date, dateCall, iva, paymentMhetod, tel, inputFields: [{id, type, amount, days}, address] }
    const contactClient = JSON.parse(client.contacts);
    const contactClientData = contactClient.filter(client => client.contactName === formValues.contact)[0];
    const { certificationDate } = formValues;

    return (
        <Stack>
            <Typography variant='caption' ><b>Móvil empresa:</b> {client.movil}</Typography>
            <Typography variant='caption'><b>Móvil persona contacto:</b> {contactClientData?.contactTel}</Typography>
            <Typography variant='caption'><b>Email:</b> {client.email}</Typography>
            <Typography variant='caption'><b>Fecha:</b> {certificationDate ? dateFormmater(certificationDate) :dateFormmater(formValues.date)}</Typography>
            <Typography variant='caption'><b>CIF:</b> {client.cif}</Typography>
        </Stack>
    )
}
